export const BASE_URL = window.location.href.includes('localhost') ? 'http://localhost:4200/api/' :'https://api-curate.pyther.com/api/'

export const AUTH_TOKEN =
    "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyX2lkIjoiZGZnaGprQGdtYWlsLmNvbW0iLCJpYXQiOjE3MzE1NjYwOTB9.5MC3Yfu4vrK6usWMo_GQPqDAd46nLoIj0j1v1ZXd7Wo";
